// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscapaisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaPais() /localidades/buscaPais
 *
 * Proxy to locations-service (Go microservice).
 * Returns a single country record by ID.
 */
import type { Localidades_BuscaestadosRow } from './Localidades_BuscaestadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_BuscapaisResponseDados {
id?: number
name?: string
code?: string
states?: Localidades_BuscaestadosRow[]
}

export type Localidades_BuscapaisResponse = ApiResponse<Localidades_BuscapaisResponseDados>;

registerResponseContract('Localidades_BuscapaisResponse', {
  id:     { type: 'number',  required: false },
  name:   { type: 'string',  required: false },
  code:   { type: 'string',  required: false },
  states: {
    type: 'array',
    required: false,
    items: {
      ID:        { type: 'number',  required: false },
      Name:      { type: 'string',  required: false },
      UF:        { type: 'string',  required: false },
      CountryID: { type: 'number',  required: false },
      Cities: {
        type: 'array',
        required: false,
        items: {
          ID:      { type: 'number',  required: false },
          Name:    { type: 'string',  required: false },
          StateID: { type: 'number',  required: false },
        },
      },
    },
  },
})
